import { Modal, Form, Input, Divider } from 'antd';

export const BeanstalkModal = ({ propsData }) => {
  const { title, open, onCancel, onOk, okText, formItems, form } = propsData;
  

  // Group form items by category
  let authFields = [];
  let headerFields = [];
  let otherFields = [];
  
  if(formItems.length > 0){
   authFields = formItems.filter((item) => item.group === 'authFields');
   headerFields = formItems.filter((item) => item.group === 'headers');
   otherFields = formItems.filter(
    (item) => !item.group || (item.group !== 'authFields' && item.group !== 'headers')
  );
}

  // Extract initial values for the form
  const initialValues = {};
  formItems.forEach((item) => {
    initialValues[item.name] = item.initialValue || '';
  });

  const handleFinish = (values) => {
    
    onOk(formItems);
  };


  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      onOk={() => form.submit()}
      okText={okText}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={initialValues} // Set initial values for the form
      >
        {/* Authentication Fields */}
        {authFields.length > 0 && (
          <>
            <Divider orientation="left">Authentication Fields</Divider>
            {authFields
              .filter((item) => item.name !== '') // Only include items where name is not an empty string
              .map((item) => (
                <Form.Item
                  key={item.name}
                  name={item.name}
                  label={item.label}
                  rules={item.rules}
                  initialValue={item.initialValue} // Set initial value for the specific field
                >
                  <Input
                    placeholder={`Enter ${item.label}`}
                    disabled={item.disabled}
                  />
                </Form.Item>
              ))}
          </>
        )}

        {/* Header Fields */}
        {headerFields.length > 0 && (
          <>
            <Divider orientation="left">Header Fields</Divider>
            {headerFields
              .filter((item) => item.name !== '') // Filter out items where name is an empty string
              .map((item) => (
                <Form.Item
                  key={item.name}
                  name={item.name}
                  label={item.label}
                  rules={item.rules}
                  initialValue={item.initialValue} // Set initial value for the specific field
                >
                  <Input
                    placeholder={`Enter ${item.label}`}
                    disabled={item.disabled}
                  />
                </Form.Item>
              ))}
          </>
        )}
        {/* Other Fields */}
        {otherFields.length > 0 && (
          <>
            <Divider orientation="left">Other Fields</Divider>
            {otherFields.map((item) => (
              <Form.Item
                key={item.name}
                name={item.name}
                label={item.label}
                rules={item.rules}
                initialValue={item.initialValue} // Set initial value for the specific field
              >
                <Input
                  placeholder={`Enter ${item.label}`}
                  disabled={item.disabled}
                />
              </Form.Item>
            ))}
          </>
        )}
      </Form>
    </Modal>
  );
};
